module.exports = __webpack_public_path__ + "img/crystal@2x.72de992.jpg";